import React, { useEffect, useRef, useState } from 'react'
import useWindowDimensions from '../hooks/useDimensions'
import { Dropdown } from 'primereact/dropdown'
import apis, { getAbsenceDays } from '../../api'
import SkeletonTable from '../SkeletonTable/SkeletonTable'
import { Card } from 'primereact/card';
import { FilterMatchMode, FilterOperator } from 'primereact/api';
import { DataTable } from 'primereact/datatable'
import { Column } from 'primereact/column'
import { Chart } from 'primereact/chart'
import { Toolbar } from 'primereact/toolbar'
import { Avatar } from 'primereact/avatar'
import { Badge } from 'primereact/badge'
import { Tooltip } from 'primereact/tooltip'
import './Dashboard.css'
import { DataView } from 'primereact/dataview'
import { classNames } from 'primereact/utils';
import { Button } from 'primereact/button'
import { Dialog } from 'primereact/dialog'
import InfoIcon from '../InfoIcon/InfoIcon'
import { TablePaginator } from '../TablePaginator/TablePaginator'
import dateFormat from '../../services/DateFormat.service'
import invDateFormat from '../../services/InvertDateFormat.service'
import { Toast } from 'primereact/toast';
import { Calendar } from 'primereact/calendar';
import { IconField } from 'primereact/iconfield'
import { InputIcon } from 'primereact/inputicon'
import { InputText } from 'primereact/inputtext'
import { InputNumber } from 'primereact/inputnumber'
import { InputTextarea } from 'primereact/inputtextarea'
import Maps2 from '../Maps/Maps2'
import { Galleria } from 'primereact/galleria'
import { addLocale } from 'primereact/api';
import { useHistory } from "react-router-dom";

const Dashboard = () => {

    const name = localStorage.getItem("name")

    const { width, height } = useWindowDimensions()

    const dateOptions = {
        weekday: 'long',
        year: 'numeric',
        month: 'long',
        day: 'numeric',
    };

    const today = new Date(Date.now()).toLocaleDateString('es-CO', dateOptions)

    const headers = {
        authorization: localStorage.getItem('token')
    }

    const entity = localStorage.getItem('entity')
    const client = localStorage.getItem('client')

    /*Propiedades de la tabla del componente*/
    const [rowDataTime, setRowDataTime] = useState([]);
    const [rowsTime, setRowsTime] = useState([]);
    const [first2Time, setFirst2Time] = useState(0);
    const [rows2Time, setRows2Time] = useState(10);
    const [selectedRowsTime, setSelectedRowsTime] = useState(null);
    const [filters1, setFilters1] = useState("");
    const [globalFilterValue1, setGlobalFilterValue1] = useState('');

    const [rowDataAcumulate, setRowDataAcumulate] = useState([]);
    const [rowsAcumulate, setRowsAcumulate] = useState([]);
    const [rowsAcumulateFilter, setRowsAcumulateFilter] = useState([]);
    const [first2Acumulate, setFirst2Acumulate] = useState(0);
    const [rows2Acumulate, setRows2Acumulate] = useState(2);
    const [selectedRowsAcumulate, setSelectedRowsAcumulate] = useState(null);

    const [rowDataBirthday, setRowDataBirthday] = useState([]);
    const [rowsBirthday, setRowsBirthday] = useState([]);
    const [rowsBirthdayFilter, setRowsBirthdayFilter] = useState([]);
    const [first2Birthday, setFirst2Birthday] = useState(0);
    const [rows2Birthday, setRows2Birthday] = useState(7);
    const [selectedRowsBirthday, setSelectedRowsBirthday] = useState(null);

    const [rowDataSchedule, setRowDataSchedule] = useState([]);
    const [rowsSchedule, setRowsSchedule] = useState([]);
    const [rowsScheduleFilter, setRowsScheduleFilter] = useState([]);
    const [first2Schedule, setFirst2Schedule] = useState(0);
    const [rows2Schedule, setRows2Schedule] = useState(2);
    const [selectedRowsSchedule, setSelectedRowsSchedule] = useState(null);

    const [week, setWeek] = useState({
        week: "",
        begin: "",
        end: ""
    })

    const [datasetAbsence, setDatasetAbsence] = useState({
        labels: [],
        datasets: [],
        name: ""
    })

    const [datasetAbsenceFilter, setDatasetAbsenceFilter] = useState({
        labels: [],
        datasets: [],
        name: ""
    })

    const [liveData, setLiveData] = useState({
        ABSENCE: [],
        ACTIVE: [],
        INACTIVE: [],
        VACATION: []
    })

    const [liveDataFilter, setLiveDataFilter] = useState({
        ABSENCE: [],
        ACTIVE: [],
        INACTIVE: [],
        VACATION: []
    })


    const [loadPage, setLoadPage] = useState(false)

    const [isOpenActive, setIsOpenActive] = useState(false)
    const [isOpenVacation, setIsOpenVacation] = useState(false)
    const [isOpenAbsence, setIsOpenAbsence] = useState(false)
    const [isOpenInactive, setIsOpenInactive] = useState(false)
    const [isOpenBirthdays, setIsOpenBirthdays] = useState(false)

    const [entityFilter, setEntityFilter] = useState("")
    const [clientFilter, setClientFilter] = useState("")

    const [entityList, setEntityList] = useState([])
    const [clientList, setClientList] = useState([])
    const [loadingAbsences, setLoadingAbsences] = useState(false)
    const [isFlickering, setIsFlickering] = useState(false)

    const [loadPending, setLoadPending] = useState(false)
    const [rows, setRows] = useState([]);
    const [first2, setFirst2] = useState(0);
    const [rows2, setRows2] = useState(2);
    const [selectedRows, setSelectedRows] = useState(null);

    const [contrato, setContrato] = useState("")
    const [fechaInicioConsulta, setFechaInicioConsulta] = useState("")
    const [fechaFinConsulta, setFechaFinConsulta] = useState("")

    const [rowState, setRowState] = useState([]);

    const [idSolicitud, setIdSolicitud] = useState("")
    const [tipo, setTipo] = useState("")
    const [consolidado, setConsolidado] = useState("")
    const [diasTiempo, setDiasTiempo] = useState("")
    const [diasDinero, setDiasDinero] = useState("")
    const [fechaInicio, setFechaInicio] = useState("")
    const [fechaFin, setFechaFin] = useState("")

    const [fechaInicioAusentismo, setFechaInicioAusentismo] = useState("")
    const [fechaFinAusentismo, setFechaFinAusentismo] = useState("")
    const [contingencia, setContingencia] = useState("")
    const [tiempo, setTiempo] = useState("")
    const [observaciones, setObservaciones] = useState("")
    const [adjunto, setAdjunto] = useState("")

    const [longitud, setLongitud] = useState(0)
    const [latitud, setLatitud] = useState(0)
    const [trackFotos, setTrackFotos] = useState([])
    const [trackInfo, setTrackInfo] = useState({})
    const [trackDescription, setTrackDescription] = useState("")

    const [listaTipo, setListaTipo] = useState([])
    const [listaContratos, setListaContratos] = useState([])
    const [listaContingencia, setListaContingencia] = useState([])

    const [registros, setRegistros] = useState([]);

    const [loading1, setLoading1] = useState(false)
    const [loading2, setLoading2] = useState(false)
    const [loading3, setLoading3] = useState(false)

    const [isOpenA, setIsOpenA] = useState(false)
    const [isOpenR, setIsOpenR] = useState(false)
    const [isOpenD, setIsOpenD] = useState(false)

    const [noveltyCauseList, setNoveltyCauseList] = useState([])
    const [noveltyCauseInfo, setNoveltyCauseInfo] = useState("")
    const [causal, setCausal] = useState("")

    const [isOpenCausal, setIsOpenCausal] = useState(false)

    const [type, setType] = useState([])

    const [isOpenMapa, setIsOpenMapa] = useState(false)

    const toast = useRef(null);
    const rowNumber = width > 768 ? 6 : width <= 768 && width > 320 ? 3 : 2

    const elementWidth = { width: "12rem" }
    const labelStyle = {
        display: "block",
        float: "left",
        marginTop: "5px",
        width: "100%",
        paddingTop: "5px"
    }

    const responsiveOptions = [
        {
            breakpoint: '991px',
            numVisible: 4
        },
        {
            breakpoint: '767px',
            numVisible: 3
        },
        {
            breakpoint: '575px',
            numVisible: 1
        }
    ];

    let history = useHistory();

    addLocale('es', {
        firstDayOfWeek: 1,
        dayNames: ['domingo', 'lunes', 'martes', 'miércoles', 'jueves', 'viernes', 'sábado'],
        dayNamesShort: ['dom', 'lun', 'mar', 'mié', 'jue', 'vie', 'sáb'],
        dayNamesMin: ['D', 'L', 'M', 'X', 'J', 'V', 'S'],
        monthNames: ['enero', 'febrero', 'marzo', 'abril', 'mayo', 'junio', 'julio', 'agosto', 'septiembre', 'octubre', 'noviembre', 'diciembre'],
        monthNamesShort: ['ene', 'feb', 'mar', 'abr', 'may', 'jun', 'jul', 'ago', 'sep', 'oct', 'nov', 'dic'],
        today: 'Hoy',
        clear: 'Claro'
    });

    useEffect(() => {
        const template = async () => {
            await apis.getPendRequests(localStorage.getItem('entity'), localStorage.getItem('client'), headers).then(res => {
                let tipos = res.data.TYPE_NOVELTIES
                let contratos = res.data["CONTRACTS"]
                setListaTipo(tipos)
                setListaContratos(contratos)
            })
        }
        const getAllData = async () => {
            await birthdays()
            await scheduling()
            await employeesNow()
            await schedulingConsolidate()
            await absences()
            await setTabla()
            await template()
        }
        getAllData()
    }, [])

    /*Funciones que manejan el comportamiento de la tabla del componente*/
    const onCustomPage2Birthday = (event) => {
        setFirst2Birthday(event.first);
        setRows2Birthday(event.rows);
    }

    const onCustomPage2Scheduling = (event) => {
        setFirst2Schedule(event.first);
        setRows2Schedule(event.rows);
    }

    const onCustomPage2 = (event) => {
        setFirst2(event.first);
        setRows2(event.rows);
    }

    const showModalA = () => {
        // if (!listasCargadas) {
        //   setListas()
        // }
        setIsOpenA(true);
    };

    const hideModalA = () => {
        setIsOpenA(false);
        setCausal("")
        // limpiar();
    };

    const showModalR = () => {
        // if (!listasCargadas) {
        //   setListas()
        // }
        setIsOpenR(true);
    };

    const hideModalR = () => {
        setIsOpenR(false);
        // limpiar();
    };

    const showModalD = () => {
        // if (!listasCargadas) {
        //   setListas()
        // }
        setIsOpenD(true);
    };

    const hideModalD = () => {
        setIsOpenD(false);
        setAdjunto("")
    };

    const showModalMapa = () => {
        // if (!listasCargadas) {
        //   setListas()
        // }
        setIsOpenMapa(true);
    };

    const hideModalMapa = () => {
        setIsOpenMapa()
    };

    const showModalCausal = () => {
        // if (!listasCargadas) {
        //   setListas()
        // }
        setIsOpenCausal(true);
    };

    const hideModalCausal = () => {
        setIsOpenCausal(false);
        //limpiar();
    };

    const dropdownOptions = [
        { label: 1, value: 1 },
        { label: 2, value: 2 },
        { label: 3, value: 3 }
    ];
    
    const template7 = TablePaginator(dropdownOptions)

    const template2 = {
        layout: 'CurrentPageReport',
        'CurrentPageReport': (options) => {
            return (
                <Button link label='Ver todos' size='small' className='p-button-sm text-xs -mt-3' onClick={() => setIsOpenActive(true)} />
            )
        },
    };

    const template3 = {
        layout: 'PrevPageLink CurrentPageReport NextPageLink',
        'CurrentPageReport': (options) => {
            return (
                <span style={{ color: 'var(--text-color)', textAlign: 'center' }} className='text-xs'>
                    {options.first} - {options.last}
                </span>
            )
        },
        'PrevPageLink': (options) => {
            return (
                <button type="button" className={classNames(options.className, 'border-none')} onClick={options.onClick} disabled={options.disabled}
                    style={{ height: '1rem', marginRight: '-1rem' }}
                >
                    <i className='pi pi-chevron-left text-xs' />
                </button>
            )
        },
        'NextPageLink': (options) => {
            return (
                <button type="button" className={classNames(options.className, 'border-none')} onClick={options.onClick} disabled={options.disabled}
                    style={{ height: '1rem', marginLeft: '-1rem' }}
                >
                    <i className='pi pi-chevron-right text-xs' />
                </button>
            )
        },
    };

    const template4 = {
        layout: 'CurrentPageReport',
        'CurrentPageReport': (options) => {
            return (
                <Button link label='Ver todos' size='small' className='p-button-sm text-xs -mt-3' onClick={() => setIsOpenVacation(true)} />
            )
        },
    };

    const template5 = {
        layout: 'CurrentPageReport',
        'CurrentPageReport': (options) => {
            return (
                <Button link label='Ver todos' size='small' className='p-button-sm text-xs -mt-3' onClick={() => setIsOpenAbsence(true)} />
            )
        },
    };

    const template6 = {
        layout: 'CurrentPageReport',
        'CurrentPageReport': (options) => {
            return (
                <Button link label='Ver todos' size='small' className='p-button-sm text-xs -mt-3' onClick={() => setIsOpenInactive(true)} />
            )
        },
    };

    const onGlobalFilterChange1 = (e) => {
        /*Filtro global de la tabla*/
        const value = e.target.value;
        let _filters1 = {
            'global': { value: null, matchMode: FilterMatchMode.CONTAINS }
        };
        _filters1['global'].value = value;

        setFilters1(_filters1);
        setGlobalFilterValue1(value);
    }

    const clearFilter1 = () => {
        console.log(filters1)
        initFilters1();
        setRows(selectedRows)
    }

    const initFilters1 = () => {
        /*Filtros de la tabla del componente*/
        setFilters1({
            'global': { value: null, matchMode: FilterMatchMode.CONTAINS },
            'NAME': { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }] },
        });
        setGlobalFilterValue1('');
    }

    const matchModes = [
        { label: 'CONTIENE', value: FilterMatchMode.CONTAINS },
        { label: 'COMIENZA CON', value: FilterMatchMode.STARTS_WITH },
        { label: 'NO CONTIENE', value: FilterMatchMode.NOT_CONTAINS },
        { label: 'TERMINA CON', value: FilterMatchMode.ENDS_WITH },
        { label: 'IGUAL A', value: FilterMatchMode.EQUALS },
        { label: 'DIFERENTE A', value: FilterMatchMode.NOT_EQUALS }
    ];

    const birthdays = async () => {
        try {
            await apis.getBirthdays(entity, client, headers).then(res => {
                setRowsBirthday(res.data.BIRTHDAYS)
                setRowsBirthdayFilter(res.data.BIRTHDAYS)
                if(res.data.BIRTHDAYS.length > 0){
                    setIsFlickering(true)
                }
            })
        }
        catch (err) {
            console.log(err)
        }
    }

    const scheduling = async () => {
        try {
            await apis.getScheduling(entity, client, headers).then(res => {
                setRowsSchedule(res.data.SHEDULES)
                setRowsScheduleFilter(res.data.SHEDULES)
            })
        }
        catch (err) {
            console.log(err)
        }
    }

    const schedulingConsolidate = async () => {
        try {
            await apis.getSchedulingConsolidate(entity, client, headers).then(res => {
                setRowsAcumulate(res.data.SHEDULES)
                setRowsAcumulateFilter(res.data.SHEDULES)
                setWeek({
                    ...week,
                    begin: res.data.WEEK_INI,
                    end: res.data.WEEK_END,
                    week: res.data.WEEK
                })
            })
        }
        catch (err) {
            console.log(err)
        }
    }

    const employeesNow = async () => {
        try {
            await apis.getMyEmployeesNow(entity, client, headers).then(res => {
                let data = res.data
                let newDataActive = []
                let newDataVacation = []
                let newDataAbsence = []
                let newDataInactive = []
                let entity_list = []
                let client_list = []
                data.ACTIVE.forEach((act, index) => {
                    let newAct = {
                        ...act,
                        MARKED: act.REST_DAY !== 'S' ? (act.IN === "1" ? "Si" : act.IN === '2' ? 'Reemplazado' : "No") : 'Descanso',
                        INDEX: index,
                        FULL_CONTRACT: act.CONTRACT_ID + ' ' + act.NAME + ' ' + act.JOB_ID + ' ' + act.ENTITY_NAME + ' ' + act.ENTITY_NAME
                    }
                    let entityIndex = entity_list.findIndex(ent => ent.CODE === act.ENTITY)
                    if(entityIndex !== -1){
                        let ent = entity_list[entityIndex]
                        let clients = [...ent.CLIENTS]
                        if(!ent.CLIENTS.some(cli => cli.CODE === act.CLIENT)){
                            let newClient = {
                                CODE: act.CLIENT,
                                NAME: act.CLIENT_NAME
                            }
                            clients.push(newClient)
                        }
                        ent = {
                            ...ent,
                            CLIENTS: [...clients]
                        }
                        entity_list[entityIndex] = ent
                    }
                    else{
                        let newClient = {
                            CODE: act.CLIENT,
                            NAME: act.CLIENT_NAME
                        }
                        let newEntity = {
                            CODE: act.ENTITY,
                            NAME: act.ENTITY_NAME,
                            CLIENTS: [newClient]
                        }
                        entity_list.push(newEntity)
                    }
                    newDataActive.push(newAct)
                })
                data.VACATION.forEach((act, index) => {
                    let newAct = {
                        ...act,
                        INDEX: index,
                        FULL_CONTRACT: act.CONTRACT_ID + ' ' + act.NAME + ' ' + act.JOB_ID + ' ' + act.ENTITY_NAME + ' ' + act.ENTITY_NAME
                    }
                    let entityIndex = entity_list.findIndex(ent => ent.CODE === act.ENTITY)
                    if(entityIndex !== -1){
                        let ent = entity_list[entityIndex]
                        let clients = [...ent.CLIENTS]
                        if(!ent.CLIENTS.some(cli => cli.CODE === act.CLIENT)){
                            let newClient = {
                                CODE: act.CLIENT,
                                NAME: act.CLIENT_NAME
                            }
                            clients.push(newClient)
                        }
                        ent = {
                            ...ent,
                            CLIENTS: [...clients]
                        }
                        entity_list[entityIndex] = ent
                    }
                    else{
                        let newClient = {
                            CODE: act.CLIENT,
                            NAME: act.CLIENT_NAME
                        }
                        let newEntity = {
                            CODE: act.ENTITY,
                            NAME: act.ENTITY_NAME,
                            CLIENTS: [newClient]
                        }
                        entity_list.push(newEntity)
                    }
                    newDataVacation.push(newAct)
                })
                data.ABSENCE.forEach((act, index) => {
                    let contingency = act.CONTINGENCY.split('|')
                    let newAct = {
                        ...act,
                        CONTINGENCY_DETAIL: contingency[1],
                        INDEX: index,
                        FULL_CONTRACT: act.CONTRACT_ID + ' ' + act.NAME + ' ' + act.JOB_ID + ' ' + act.ENTITY_NAME + ' ' + act.ENTITY_NAME
                    }
                    let entityIndex = entity_list.findIndex(ent => ent.CODE === act.ENTITY)
                    if(entityIndex !== -1){
                        let ent = entity_list[entityIndex]
                        let clients = [...ent.CLIENTS]
                        if(!ent.CLIENTS.some(cli => cli.CODE === act.CLIENT)){
                            let newClient = {
                                CODE: act.CLIENT,
                                NAME: act.CLIENT_NAME
                            }
                            clients.push(newClient)
                        }
                        ent = {
                            ...ent,
                            CLIENTS: [...clients]
                        }
                        entity_list[entityIndex] = ent
                    }
                    else{
                        let newClient = {
                            CODE: act.CLIENT,
                            NAME: act.CLIENT_NAME
                        }
                        let newEntity = {
                            CODE: act.ENTITY,
                            NAME: act.ENTITY_NAME,
                            CLIENTS: [newClient]
                        }
                        entity_list.push(newEntity)
                    }
                    newDataAbsence.push(newAct)
                })
                data.INACTIVE.forEach((act, index) => {
                    let newAct = {
                        ...act,
                        INDEX: index,
                        FULL_CONTRACT: act.CONTRACT_ID + ' ' + act.NAME + ' ' + act.JOB_ID + ' ' + act.ENTITY_NAME + ' ' + act.ENTITY_NAME
                    }
                    let entityIndex = entity_list.findIndex(ent => ent.CODE === act.ENTITY)
                    if(entityIndex !== -1){
                        let ent = entity_list[entityIndex]
                        let clients = [...ent.CLIENTS]
                        if(!ent.CLIENTS.some(cli => cli.CODE === act.CLIENT)){
                            let newClient = {
                                CODE: act.CLIENT,
                                NAME: act.CLIENT_NAME
                            }
                            clients.push(newClient)
                        }
                        ent = {
                            ...ent,
                            CLIENTS: [...clients]
                        }
                        entity_list[entityIndex] = ent
                    }
                    else{
                        let newClient = {
                            CODE: act.CLIENT,
                            NAME: act.CLIENT_NAME
                        }
                        let newEntity = {
                            CODE: act.ENTITY,
                            NAME: act.ENTITY_NAME,
                            CLIENTS: [newClient]
                        }
                        entity_list.push(newEntity)
                    }
                    newDataInactive.push(newAct)
                })
                data = {
                    ...data,
                    ACTIVE: newDataActive,
                    VACATION: newDataVacation,
                    ABSENCE: newDataAbsence,
                    INACTIVE: newDataInactive

                }
                // setClientList(client_list)
                setEntityList(entity_list)
                setLiveData(data)
                setLiveDataFilter(data)
                setLoadPage(true)
            })
        }
        catch (err) {
            console.log(err)
            setLoadPage(true)
        }
    }

    const absences = async (entity_ = -1, client_ = -1) => {
        setLoadingAbsences(false)
        try {
            await apis.getAbsenceDays(entity, client, headers, entity_, client_).then(res => {
                setDatasetAbsence({ ...datasetAbsence, ...res.data, labels: res.data.label })
                setDatasetAbsenceFilter({ ...datasetAbsence, ...res.data, labels: res.data.label })
            })
        }
        catch (err) {
            console.log(err)
        }
        finally{
            setLoadingAbsences(true)
        }
    }

    const photoBodyTemplate = (rowData) => {
        let photo = rowData.IMAGES ? rowData.IMAGES : process.env.REACT_APP_PROFILE_PIC
        if (rowData.NAME) {
            return (
                <div className='flex flex-row justify-content-start align-items-center gap-1'>
                    <div
                        style={{
                            width: '50px',
                            height: '50px',
                            minWidth: '50px',
                            borderRadius: '50%',
                            overflow: 'hidden',
                            flexShrink: 0
                        }}
                    >
                        <img
                            src={photo}
                            alt=""
                            loading="eager"
                            style={{
                                width: '100%',
                                height: '100%',
                                objectFit: 'cover'
                            }}
                        />
                    </div>
                    <div className='flex flex-column ml-2 align-self-center'>
                        <span className='font-bold'>{rowData.NAME}</span>
                        <span>{rowData.CONTRACT_ID} - {rowData.JOB_ID}</span>
                    </div>
                </div>
            );
        }
    }

    let options = {
        responsive: true,
        maintainAspectRatio: false,
        layout: {
            padding: {
                top: width <= 768 && 10,
                bottom: width <= 768 && 10,
            }
        },
        plugins: {
            tooltip: {
                position: 'average',
                borderWidth: '100',
                callbacks: {
                    labelTextColor: function (context) {
                        return 'white';
                    },
                    label: function (dataset) {
                        let label = dataset.label
                        let data = dataset.parsed
                        console.log(data)

                        if (label) {
                            label += ': ';
                        }
                        label += data.y;
                        return label;
                    }
                }
            },
            // title: {
            //     display: true,
            //     text: datasetAbsence.name,
            //     color: 'black',
            //     font: {
            //         size: '20',
            //     },
            //     padding: {
            //         top: 0
            //     }
            // },
            legend: {
                align: 'center',
                display: true,
                position: 'top',
                labels: {
                    boxWidth: width > 768 ? 28 : 12,   // smaller legend boxes on mobile
                    font: {
                        size: width > 768 ? 12 : 10      // smaller font on mobile
                    }
                }
            }
        }
    }

    const startToolbarTemplate = () => {
        return (
            <div className='flex align-content-center gap-3'>
                <label className='flex align-self-center'>Semana {week.week}</label>
            </div>
        )
    }

    const endToolbarTemplate = () => {
        return (
            <div className='flex align-content-center gap-3'>
                <label className='flex align-self-center'>{week.begin} a {week.end}</label>
            </div>
        )
    }

    const employeeTemplate = (employee, type) => {
        let tooltip = employee.CONTRACT_ID + '\n' + employee.NAME + '\n' + employee.JOB_ID + '\nEmpresa: ' + employee.ENTITY_NAME + '\nCliente: ' + employee.CLIENT_NAME
        let func
        switch (type) {
            case 'active':
                const marked = employee.REST_DAY !== 'S' ? (employee.IN === '1' ? 'Ingresado' : employee.IN === '2' ? 'Reemplazado' : 'No ingresado') : "Descanso"
                tooltip = tooltip + '\n' + marked
                func = () => setIsOpenActive(true)
                break;
            case 'vacation':
                func = () => setIsOpenVacation(true)
                break;
            case 'absence':
                tooltip = tooltip + '\n' + employee.CONTINGENCY_DETAIL
                func = () => setIsOpenAbsence(true)
                break;
            case 'inactive':
                func = () => setIsOpenInactive(true)
                break;
        }
        if (employee.INDEX === 5 || (employee.INDEX === 2 && width <= 768 && width > 320) || (employee.INDEX === 1 && width <= 320)) {
            return (
                <>
                    <Tooltip target=".custom-target-icon" style={{ maxWidth: '16rem' }} />
                    <Avatar className="custom-target-icon p-overlay-badge mr-2 mb-2" label='+' shape="circle"
                        data-pr-tooltip="Ver más"
                        data-pr-position="right"
                        data-pr-at="right+5 top"
                        data-pr-my="left center-2"
                        onClick={func}
                    >
                    </Avatar>
                </>
            )
        }
        return (
            <>
                <Tooltip target=".custom-target-icon" style={{ maxWidth: '16rem' }} />
                <Avatar className="custom-target-icon p-overlay-badge mr-2 mb-2" image={employee.IMAGES} shape="circle"
                    data-pr-tooltip={tooltip}
                    data-pr-position="left"
                    data-pr-at="left+5 top"
                    data-pr-my="right center-2"
                >
                    {type === 'active' && <Badge className={employee.REST_DAY === 'S' && 'resting'} 
                    severity={employee.REST_DAY !== 'S' && (employee.IN === '1' ? 'success' : employee.IN === '2' ? 'warning' : 'danger')} />}
                </Avatar>
            </>
        )
    }

    const breakStyle = width <= 768 ? { textOverflow: 'ellipsis', overflow: 'hidden', whiteSpace: 'nowrap' } : {}

    const employeeTableTemplate = (employee, type) => {
        return (
            <div className='flex flex-row justify-content-start align-items-center gap-1'>
                <Avatar className="custom-target-icon p-overlay-badge mr-2 mb-2" image={employee.IMAGES} shape="circle">
                    {type === 'active' && 
                    <Badge className={employee.REST_DAY === 'S' && 'resting'} 
                    severity={employee.REST_DAY !== 'S' && (employee.IN === '1' ? 'success' : employee.IN === '2' ? 'warning' : 'danger')} />}
                </Avatar>
                <div className='flex flex-column ml-2 align-self-center'>
                    <span style={breakStyle} className='font-bold'>{employee.NAME}</span>
                    <span style={breakStyle}>{employee.CONTRACT_ID} - {employee.JOB_ID}</span>
                    <span style={breakStyle}><span className='font-bold'>Empresa: </span>{employee.ENTITY_NAME}</span>
                    <span style={breakStyle}><span className='font-bold'>CLIENTE: </span>{employee.CLIENT_NAME}</span>
                    {employee.MARKED && <span style={breakStyle}><span className='font-bold'>Ingreso: </span>{employee.MARKED}</span>}
                    {employee.CONTINGENCY_DETAIL && <span style={breakStyle}><span className='font-bold'>Contingencia: </span>{employee.CONTINGENCY_DETAIL}</span>}
                </div>
            </div>
        )
    }

    const titleTemplate = (title) => {
        const title_ = <span style={{ maxWidth: '7rem', textOverflow: 'ellipsis', overflow: 'hidden', whiteSpace: 'nowrap' }} >{title}</span>
        return (
            <Toolbar className='titlebar w-full font-bold flex text-center' center={(title.length > 10 && ((width <= 1024 && width > 768) || width <= 375)) ? title_ : title}
                style={{ background: 'linear-gradient(90deg, rgba(16, 97, 162, 1) 0%, rgba(2, 150, 207, 1) 100%)', color: 'white', maxWidth:'none', maxHeight: '20vh' }}
            />
        )
    }

    const birthdayHeader = [
        <>
            <i className='pi pi-gift text-xs'></i> Cumpleaños del mes <i className='pi pi-gift text-xs'></i>
        </>
    ]    

    const rightToolbarTemplate = () => {
        const msg = "Para filtrar la información, seleccione una empresa.\n Esto habilitará los clientes pertenecientes a dicha empresa\n y se podrá realizar el filtro por ambos campos"
        const rightClassname = 'flex align-content-center gap-2 ' + (width > 768 ? 'flex-row' : 'flex-column')
        return(
            <div className={rightClassname}>
                <Tooltip target=".info" className='indigo-tooltip ml-1'/>
                <div className='flex flex-row gap-1 align-items-center'>     
                    <Button className={`p-button-xs text-md ${isFlickering ? 'flickering' : ''}`} style={{backgroundColor: 'white', color: 'rgba(16, 97, 162, 1)'}} icon='pi pi-gift' label='Ver cumpleaños' onClick={() => {setIsFlickering(false); setIsOpenBirthdays(true)}} color='white'/>
                    <i className="info pi pi-info-circle cursor-pointer" data-pr-tooltip={msg} data-pr-position='bottom'
                        data-pr-classname="text-primary" style={{ color: 'white', fontSize: '1.2rem' }} />
                </div>
                <Dropdown value={entityFilter} options={entityList} onChange={(e) => filterByEntity(e.value)} optionLabel="NAME" showClear
                    placeholder="Empresa" style={{ width: '15rem' }} tooltip={entityFilter?.NAME} tooltipOptions={{position: 'top'}}/>
                <Dropdown value={clientFilter} options={clientList} onChange={(e) => filterByClient(e.value)} optionLabel="NAME" showClear disabled={!entityFilter}
                    placeholder="Cliente" style={{ width: '15rem' }} tooltip={clientFilter?.NAME} tooltipOptions={{position: 'top'}}/>
            </div>
        )
    }

    const leftToolbarTemplate = () => {
        return(
            <div className='flex flex-column justify-content-center align-items-start gap-1'>
                <span className='w-full'>Bienvenido(a), <span className='w-full font-bold'>{name}</span></span>
                &nbsp;
                <span>{today}</span>
            </div>
        )
    }

    const applyFilters = (entity_, client_, rowsSource) => {
        let filteredLiveData = {};
        let filteredBirthdays = [...rowsBirthday];
        let filteredAcumulate = [...rowsAcumulate];
        let filteredSchedule = [...rowsSchedule];
        let filteredRows = [...(rowsSource ?? selectedRows)] 
    
        Object.keys(liveData).forEach(key => {
            filteredLiveData[key] = liveData[key].filter(item => {
                const matchEntity = entity_
                    ? String(item.ENTITY) === String(entity_.CODE)
                    : true;
    
                const matchClient = client_
                    ? String(item.CLIENT) === String(client_.CODE)
                    : true;
    
                return matchEntity && matchClient;
            });
            let newData = []
            filteredLiveData[key].forEach((item, index) => {
                console.log(index)
                let newItem = {
                    ...item,
                    INDEX: index
                }
                newData.push(newItem)
            })
            filteredLiveData[key] = [...newData]
        });

    
        filteredBirthdays = filteredBirthdays.filter(row => {
            const matchEntity = entity_ ? row.ENTITY === entity_.CODE : true;
            const matchClient = client_ ? row.CLIENT === client_.CODE : true;
            return matchEntity && matchClient;
        });
    
        filteredAcumulate = filteredAcumulate.filter(row => {
            const matchEntity = entity_ ? row.ENTITY === entity_.CODE : true;
            const matchClient = client_ ? row.CLIENT === client_.CODE : true;
            return matchEntity && matchClient;
        });
    
        filteredSchedule = filteredSchedule.filter(row => {
            const matchEntity = entity_ ? row.ENTITY === entity_.CODE : true;
            const matchClient = client_ ? row.CLIENT === client_.CODE : true;
            return matchEntity && matchClient;
        });

        filteredRows = filteredRows.filter(row => {
            const matchEntity = entity_ ? row.ENTITY === entity_.CODE : true;
            const matchClient = client_ ? row.CLIENT === client_.CODE : true;
            return matchEntity && matchClient;
        });

        console.log(filteredLiveData)
        console.log(filteredRows)

        let absenceEntity = entity_ ? entity_.CODE : -1 

        let absenceClient = client_ ? client_.CODE : -1 

        absences(absenceEntity, absenceClient)
    
        setLiveDataFilter({ ...filteredLiveData });
        setRowsBirthdayFilter(filteredBirthdays);
        setRowsAcumulateFilter(filteredAcumulate);
        setRowsScheduleFilter(filteredSchedule);
        setRows(filteredRows)
    };

    const filterByEntity = (entity_, table = false) => {
        setEntityFilter(entity_);
        if(!table){
            setClientFilter("")
        }
        setClientList(entity_?.CLIENTS ? entity_.CLIENTS : [])
        applyFilters(entity_, entity_  ? clientFilter : undefined, selectedRows);
    };

    const filterByClient = (client_) => {
        setClientFilter(client_);
        applyFilters(entityFilter, client_ ? client_ : undefined, selectedRows);
    };

    const getCauseList = async () => {
        const _entity = localStorage.getItem('entity')
        const _client = localStorage.getItem('client')
        try {
            await apis.noveltyCauseList(_entity, _client, headers).then(res => {
                setNoveltyCauseInfo(res.data.OBSERVATION)
                setNoveltyCauseList(res.data.TRK_APD_CAUSAL)
            })
        }
        catch (error) {
            console.log(error)
        }
    }

    const getRequestDetail = async (id) => {
        const _entity = localStorage.getItem('entity')
        const _client = localStorage.getItem('client')
        console.log(tipo)
        try {
            await apis.getRequest(_entity, _client, id, headers).then(res => {
                let solicitud = res.data
                let tipo = solicitud.NOVELTY.split("|")
                if (tipo[0] === "VAC") {
                    setConsolidado(solicitud.DAY_CSO)
                    setDiasDinero(solicitud.DAYS_DIN)
                    setDiasTiempo(solicitud.DAYS_TIE)
                    setFechaInicio(invDateFormat(solicitud.START_DATE))
                    setFechaFin(invDateFormat(solicitud.END_DATE))
                    if (solicitud.FILES && solicitud.FILES.length > 0) {
                        let adjuntos = solicitud.FILES[0]
                        setAdjunto(adjuntos)
                    }
                }
                else if (tipo[0] === "ABS") {
                    let _contingencia = solicitud.CONTINGENCY.split("|")
                    setFechaInicioAusentismo(invDateFormat(solicitud.START_DATE))
                    setFechaFinAusentismo(invDateFormat(solicitud.END_DATE))
                    setContingencia({ CODE: _contingencia[0], TYPE: _contingencia[0], NAME: _contingencia[1] })
                    setTiempo(solicitud.DAYS)
                    setObservaciones(solicitud.OBSERVATIONS)
                    if (solicitud.FILES && solicitud.FILES.length > 0) {
                        let adjuntos = solicitud.FILES[0]
                        setAdjunto(adjuntos)
                    }
                }
                else if (tipo[0] === "TRK") {
                    console.log(solicitud)
                    let location = solicitud.GEOLOCATION
                    let imagenes = {
                        ICON: solicitud.IMAGES ? solicitud.IMAGES : "",
                        DETAIL: solicitud.FILES ? solicitud.FILES : []
                    }
                    let info = {
                        DATE: solicitud.DATE ? solicitud.DATE : "",
                        TIME: solicitud.TIME ? solicitud.TIME : "",
                        TYPE: solicitud.TYPE ? solicitud.TYPE : "",
                        STATUS: solicitud.STATUS ? solicitud.STATUS : "",
                        NUMBER_ID: solicitud.NUMBER_ID
                    }
                    setLongitud(parseFloat(location.LON))
                    setLatitud(parseFloat(location.LAT))
                    setTrackDescription(solicitud.CONTRACT_ID)
                    setTrackFotos(imagenes)
                    setTrackInfo({
                        ...trackInfo,
                        ...info
                    })
                }
                else if (tipo[0] === "TURN") {
                    let location = solicitud.GEOLOCATION
                    location[0]["LAT"] = parseFloat(location[0]["LAT"])
                    location[0]["LON"] = parseFloat(location[0]["LON"])
                    location[1]["LAT"] = parseFloat(location[1]["LAT"])
                    location[1]["LON"] = parseFloat(location[1]["LON"])
                    let imagenes = {
                        ICON: solicitud.IMAGES ? solicitud.IMAGES : "",
                        DETAIL: solicitud.FILES ? solicitud.FILES : []
                    }
                    let info = {
                        DATE_IN: solicitud.DATE_IN ? solicitud.DATE_IN : "",
                        DATE_OUT: solicitud.DATE_OUT ? solicitud.DATE_OUT : "",
                        TIME_IN: solicitud.TIME_IN ? solicitud.TIME_IN : "",
                        TIME_OUT: solicitud.TIME_OUT ? solicitud.TIME_OUT : "",
                        STATUS: solicitud.STATUS ? solicitud.STATUS : "",
                        NUMBER_ID: solicitud.NUMBER_ID,
                        TURN_HE_ADI: solicitud.TURN_HE_ADI
                    }
                    setLongitud([location[0]['LON'], location[1]['LON']])
                    setLatitud([location[0]['LAT'], location[1]['LAT']])
                    setTrackDescription(solicitud.CONTRACT_ID)
                    setTrackFotos([imagenes, imagenes])
                    setTrackInfo({
                        ...trackInfo,
                        ...info
                    })
                }
            })
            showModalD()
        }
        catch (err) {
            toast.current.show({ severity: 'warn', summary: 'Aviso', detail: err.response.data.message, sticky: true });
        }
    }

    const setTabla = async () => {
        setLoadPending(false)
        const _entity = localStorage.getItem('entity')
        const _client = localStorage.getItem('client')
        const _contract = contrato ? contrato.CODE : "NULL"
        const _estado = 'PDTE'
        const _fechaInicio = fechaInicioConsulta ? dateFormat(fechaInicioConsulta) : "NULL"
        const _fechaFin = fechaFinConsulta ? dateFormat(fechaFinConsulta) : "NULL"

        try {
            await apis.getAllRequests(_entity, _client, _estado, _contract, _fechaInicio, _fechaFin, headers).then(res => {
                if (res.data.NOVELTIES.length > 0) {
                    let data = res.data.NOVELTIES
                    let solicitudes = []
                    let states = {}
                    let rowCounter = 0;
                    data.forEach(element => {
                        let registro = element
                        let solicitud = registro.NOVELTY.split("|")
                        let contrato = registro.CONTRACT_ID.split("|")
                        let estado = registro.STATUS.split("|")
                        let idSolicitud = solicitud[0]
                        let idContrato = contrato[0]
                        let idEstado = estado[0]
                        solicitud = solicitud[1]
                        contrato = contrato[1]
                        estado = estado[1]
                        registro.NOVELTY = solicitud
                        registro.CONTRACT_ID = idContrato
                        registro.STATUS = estado
                        registro = {
                            ...registro,
                            NOVELTY_ID: idSolicitud,
                            CONTRACT: contrato,
                            STATUS_ID: idEstado,
                            rowId: rowCounter,
                        }
                        states = {
                            ...states,
                            [rowCounter]: false
                        }
                        solicitudes.push(registro)
                        rowCounter++
                    });
                    setRowState(states)
                    setRows(solicitudes)
                    getCauseList()
                    setSelectedRows(solicitudes)
                    console.log(solicitudes)
                    setType([])
                    setLoadPending(true)
                    if (entityFilter) {
                        applyFilters(entityFilter, clientFilter || undefined, solicitudes)
                    }
                    // toast.current.show({ severity: 'success', summary: 'Éxito', detail: "Consulta exitosa" })
                }
                else {
                    setRows([])
                    setSelectedRows([])
                    setType([])
                    setLoadPending(true)
                    // toast.current.show({ severity: 'warn', summary: 'Éxito', detail: "Consulta sin resultados" })
                }
                setLoading1(false)
                setLoadPending(true)
            })
        }
        catch (err) {
            setRows([])
            setLoadPending(true)
            setLoading1(false)
            // toast.current.show({ severity: 'warn', summary: 'Aviso', detail: err.response.data.message, sticky: true });
        }
    }


    const group1 = [
        <div className='flex flex-row w-full text-xs'>
            <Card header={titleTemplate('Programado')} style={{ width: "50%", height: width > 768 ? '30vh' : '28vh' }}
                className='card flex justify-content-start'
            >
                {liveDataFilter.ACTIVE.length > 0 &&
                    <>
                        <DataView value={liveDataFilter.ACTIVE} itemTemplate={(item) => employeeTemplate(item, 'active')} className={width <= 1024 && width > 768 && '-mt-4'}
                            paginatorClassName='text-xs border-none' paginator paginatorTemplate={template2} layout={'grid'} rows={rowNumber}/>
                    </>
                }
            </Card>
            <Card header={titleTemplate('Vacaciones')} style={{ width: "50%", height: width > 768 ? '30vh' : '28vh' }}
                className='card flex justify-content-start'
            >
                {liveDataFilter.VACATION.length > 0 &&
                    <>
                        <DataView value={liveDataFilter.VACATION} itemTemplate={(item) => employeeTemplate(item, 'vacation')} className={width <= 1024 && width > 768 && '-mt-4'}
                            paginatorClassName='text-xs border-none' paginator paginatorTemplate={template4} layout={'grid'} rows={rowNumber}/>
                    </>
                }
            </Card>
        </div>,
        <div className='flex flex-row w-full text-xs'>
            <Card header={titleTemplate('Ausentimos')} style={{ width: "50%", height: width > 768 ? '30vh' : '28vh' }}
                className='card flex justify-content-start'
            >
                {liveDataFilter.ABSENCE.length > 0 &&
                    <>
                        <DataView value={liveDataFilter.ABSENCE} itemTemplate={(item) => employeeTemplate(item, 'absence')} className={width <= 1024 && width > 768 && '-mt-4'}
                            paginatorClassName='text-xs border-none' paginator paginatorTemplate={template5} layout={'grid'} rows={rowNumber} /><br />
                    </>
                }
            </Card>
            <Card header={titleTemplate('Sin programación')} style={{ width: "50%", height: width > 768 ? '30vh' : '28vh' }}
                className='card flex justify-content-start'
            >
                {liveDataFilter.INACTIVE.length > 0 &&
                    <>
                        <DataView value={liveDataFilter.INACTIVE} itemTemplate={(item) => employeeTemplate(item, 'inactive')} className={width <= 1024 && width > 768 && '-mt-4'}
                            paginatorClassName='text-xs border-none' paginator paginatorTemplate={template6} layout={'grid'} rows={rowNumber} /><br />
                    </>

                }
            </Card>
        </div>
    ]

    const group2 = [
        <div className={width <= 768 && 'w-full'}>
            <Toolbar className='card flex flex-row bg-white' start={startToolbarTemplate} end={endToolbarTemplate}
                style={{ background: 'linear-gradient(90deg, rgba(16, 97, 162, 1) 0%, rgba(2, 150, 207, 1) 100%)', color: 'white', width: width > 768 ? '50vw' : '100%', maxWidth: '100%'}}
            />
            <Card className='newCard card flex align-content-start' style={{ maxHeight: '52.5vh', width: width > 768 ? '50vw' : '100%' }}>

                <DataTable className="card text-xs w-full" value={rowsAcumulateFilter} rows={rows2Acumulate} dataKey="NUMBER_ID" size="small"
                    header='Horas y recargos de la semana acumulado' paginator paginatorTemplate={template3} first={first2Acumulate}
                >
                    <Column field="ENTITY_NAME" header="Empresa"></Column>
                    <Column field="CLIENT_NAME" header="Cliente"></Column>
                    <Column field="RDF" header="RDF"></Column>
                    <Column field="RN" header="RN"></Column>
                    <Column field="RNF" header="RNF"></Column>
                    <Column field="HED" header="HED"></Column>
                    <Column field="HEN" header="HEN"></Column>  
                    <Column field="HENF" header="HENF"></Column>
                    <Column field="TOTAL_RN" header="Total RN"></Column>
                    <Column field="TOTAL_HE" header="Total HE"></Column>
                </DataTable>
                <DataTable className="card text-xs w-full" value={rowsScheduleFilter} paginator paginatorTemplate={template3} first={first2Schedule} rows={rows2Schedule}
                    onPage={onCustomPage2Scheduling} dataKey="NUMBER_ID"
                    size="small" filters={filters1} filterDisplay="menu" scrollable={width <= 1024 && width > 768 ? true : false} scrollHeight={width <= 1024 && width > 768 && "30vh"}
                    globalFilterFields={['NUMBER_ID', 'NAME', 'BIRTHDAY']}
                    header='Horas y recargos de la semana acumulados por empleado'
                >
                    <Column field="NUMBER_ID" header="Empleado" body={photoBodyTemplate} filterMatchModeOptions={matchModes} filter filterPlaceholder="Buscar por id" sortable></Column>
                    <Column field="ENTITY_NAME" header="Empresa"></Column>
                    <Column field="CLIENT_NAME" header="Cliente"></Column>
                    <Column field="RDF" header="RDF"></Column>
                    <Column field="RN" header="RN"></Column>
                    <Column field="RNF" header="RNF"></Column>
                    <Column field="HED" header="HED"></Column>
                    <Column field="HEN" header="HEN"></Column>
                    <Column field="HENF" header="HENF"></Column>
                    <Column field="TOTAL_RN" header="Total RN"></Column>
                    <Column field="TOTAL_HE" header="Total HE"></Column>
                </DataTable>
            </Card>
        </div>
        ,
        <SkeletonTable load={loadingAbsences} width='100%'>
            <Card className='card' header={titleTemplate(datasetAbsenceFilter.name)} style={{ height: width > 768 ? '60vh' : '100vh', width: width > 768 ? '50vw' : '100%' }}>
                <div style={{ 
                    position: 'relative', 
                    height: width > 768 ? '45vh' : '55vh',
                    overflow: 'hidden',
                    width: '100%'
                }}>
                    <Chart
                        type="line"
                        data={datasetAbsenceFilter}
                        options={options}
                        style={{ width: '100%', height: '100%' }}                
                    />
                </div>
            </Card>
        </SkeletonTable>
    ]

    const rightToolbarTemplatePending = () => {
        const rightClassName = 'flex align-content-center flex-wrap gap-2 '
        return (
            <div className={rightClassName}>
                <Button loading={loading1} label="Consultar" icon="pi pi-search" className=" mr-2 p-button-sm" disabled={!loadPending} onClick={() => { setLoading1(true); setTabla() }} />
                <Button disabled={registros.length < 1} label="Aprobar" icon="pi pi-check" className=" mr-2 p-button-sm p-button-success" onClick={() => { showModalA() }} />
                <Button disabled={registros.length < 1} label="Rechazar" icon="pi pi-times" className=" mr-2 p-button-sm p-button-danger" onClick={() => { showModalR() }} />
                <Button label="Ver todas" icon="pi pi-calendar" className=" mr-2 p-button-sm p-button-info" onClick={() => { history.push('Pending') }} />
            </div>
        )
    }

    const selectItemTemplatePending = (option) => {
        return (
            <div className="flex jsutify-content-start align-items-center">
                <img alt={""} src={option.IMAGES} width={50} height={50} style={{ verticalAlign: 'middle', borderRadius: '40px' }} />
                &nbsp;
                &nbsp;
                &nbsp;
                <span>{option.CODE} - {option.NAME}</span>
            </div>
        );
    };

    const leftToolbarTemplatePending = () => {
        return (
            <div className='flex align-content-center gap-3'>
                <label className='flex align-self-center font-bold'>Novedades pendientes</label>
            </div>
        )
    }

    const renderHeader1 = () => {
        const msg = "Para filtrar la información, seleccione uno o varios tipos de novedades.\n Si lo desea, seleccione una empresa. Esto habilitará los clientes\n pertenecientes a dicha empresa y se podrá realizar el filtro por los 3 campos"
        const leftClassName = 'flex align-items-center align-content-center flex-wrap gap-2 ' + (width > 768 ? 'flex-row' : 'flex-column')
        return (
            <div className="barra1">
                <div className={leftClassName}>
                    <Button type="button" icon="pi pi-filter-slash" label="Limpiar filtros" className="p-button-outlined p-button-sm" onClick={clearFilter1} />
                    <Dropdown value={contrato} autofocus optionLabel='NAME' style={{ width: '12rem' }} itemTemplate={selectItemTemplatePending}
                        filter showClear filterBy="NAME,CODE" emptyMessage={"No hay contratos disponibles"}
                        onChange={(e) => setContrato(e.value)} options={listaContratos} placeholder="Contrato" />
                    <Calendar id="navigators" value={fechaInicioConsulta} onChange={(e) => setFechaInicioConsulta(e.value)} locale="es"
                        dateFormat="dd-mm-yy" yearRange="2010:2030" showIcon
                        placeholder="Fecha inicio" style={{ width: '12rem' }}
                    />
                    <Calendar id="navigators" value={fechaFinConsulta} onChange={(e) => setFechaFinConsulta(e.value)} locale="es"
                        dateFormat="dd-mm-yy" yearRange="2010:2030" showIcon
                        placeholder="Fecha fin" style={{ width: '12rem' }}
                    />
                </div>
                <IconField iconPosition="left" style={{marginTop: width <= 768 && '0.5rem'}}>
                    <InputIcon className="pi pi-search"> </InputIcon>
                    <InputText value={globalFilterValue1} onChange={onGlobalFilterChange1} placeholder="Palabra clave" className="p-inputtext-sm" />
                </IconField>
            </div>
        )
    }

    const header1 = renderHeader1();

    const changeStatus = async (status) => {
        const _entity = localStorage.getItem('entity')
        const _client = localStorage.getItem('client')
        let noveltyCause = []
        let novelties = ''
        let msg = status === 'REC' ? 'Rechazada(s)' : 'Aprobada(s)'
        registros.forEach(reg => {
            novelties = novelties + (reg.REQUESTS_ID + ",")
            if (reg.TURN_HE_ADI && reg.TURN_HE_ADI === 'S') {
                noveltyCause.push(reg)
            }
        })
        novelties = novelties.slice(0, -1)

        const requests = {
            ENTITY: _entity,
            CLIENT: _client,
            STATUS: status,
            NOVELTIES: novelties,
            TURN_CAUSAL: causal && causal.detail_id
        }

        if (noveltyCause.length === 0 || registros.length === 1) {
            try {
                await apis.putRequests(requests, headers).then(res => {
                    setLoading2(false)
                    setLoading3(false)
                    toast.current.show({ severity: 'success', summary: 'Éxito', detail: "Solicitud(es) " + msg + " exitosamente" });
                    setTabla()
                    setRegistros([])
                    hideModalA()
                    hideModalR()
                })
            }
            catch (err) {
                setLoading2(false)
                setLoading3(false)
                toast.current.show({ severity: 'warn', summary: 'Aviso', detail: err.response.data.message, sticky: true });
            }
        }
        else {
            let newMsg = ""
            noveltyCause.forEach((nov, index) => {
                if (index + 1 < noveltyCause.length) {
                    newMsg += nov.REQUESTS_ID + ", "
                }
                else {
                    newMsg += nov.REQUESTS_ID
                }
            })
            newMsg = "Para el(los) registro(s) " + newMsg + ": " + noveltyCauseInfo
            setLoading2(false)
            setLoading3(false)
            toast.current.show({ severity: 'warn', summary: 'Aviso', detail: newMsg, sticky: true });
        }
    }

    async function initializeData(row) {
        setIdSolicitud(row.REQUESTS_ID)
        setTipo(row.NOVELTY_ID)
    }

    const actionBodyTemplate = (rowData) => {
        return (
            <div style={{ width: "10rem" }}>
                <Button icon="pi pi-align-justify" className="p-button-warning mr-2 p-button-sm text-xs" tooltip="Detalle" 
                loading={rowState[rowData.rowId]}
                onClick={async () => { 
                    setRowState({ ...rowState, [rowData.rowId]: true });
                    initializeData(rowData);
                    await getRequestDetail(rowData.REQUESTS_ID).then(res => {
                        setRowState({ ...rowState, [rowData.rowId]: false });
                    })
                }} 
                />
                <Button icon="pi pi-check" className="p-button-success mr-1 p-button-sm text-xs" tooltip="Aprobar" tooltipOptions={{ position: 'top' }}
                    onClick={() => {
                        setRegistros([rowData]);
                        if (rowData.TURN_HE_ADI && rowData.TURN_HE_ADI === 'S') {
                            showModalCausal()
                        }
                        else {
                            showModalA()
                        }
                    }} />
                <Button icon="pi pi-times" className="p-button-danger p-button-sm text-xs" tooltip="Rechazar" tooltipOptions={{ position: 'top' }} onClick={() => { setRegistros([rowData]); showModalR() }} />
            </div>
        )
    }

    const footerAprobar = (
        <div>
            <Button label="Si" loading={loading2} onClick={() => { setLoading2(true); changeStatus('APD') }} />
            <Button label="No" onClick={() => hideModalA()} />
        </div>
    );

    const headerAprobar = (
        <div>
            <h3>{registros.length > 1 ? '¿Desea aprobar las solicitudes seleccionadas?' : '¿Desea aprobar esta solicitud?'}</h3>
        </div>
    )

    const footerRechazar = (
        <div>
            <Button label="Si" loading={loading3} onClick={() => { setLoading3(true); changeStatus('REC') }} />
            <Button label="No" onClick={() => hideModalR()} />
        </div>
    );

    const headerRechazar = (
        <div>
            <h3>{registros.length > 1 ? '¿Desea rechazar las solicitudes seleccionadas?' : '¿Desea rechazar esta solicitud?'}</h3>
        </div>
    )

    const detailHeader = (
        <div>
            <h3>Detalle solicitud</h3>
        </div>
    );

    const itemTemplate = (item) => {
        return <img src={item.URL ? item.URL : item} alt={item.NAME_FILE ? item.NAME_FILE : 'photo'} style={{ width: '100%', display: 'block', maxHeight: '50vh', 
            height: 'auto', objectFit: 'contain', display: 'block' }} />;
    }

    const thumbnailTemplate = (item) => {
        return <img src={item.URL ? item.URL : item} alt={item.NAME_FILE ? item.NAME_FILE : 'photo'} style={{ display: 'block', maxHeight: "100px", maxWidth: "150px" }} />;
    }

    const addFooterCausal = (
        <div>
            <Button onClick={hideModalCausal} label='Cancelar' />
            <Button label='Aceptar' disabled={!causal} onClick={() => { showModalA(); hideModalCausal() }} />
        </div>
    );

    const addHeaderCausal = (
        <div>
            <h3>{noveltyCauseInfo}</h3>
        </div>
    );

    const buttonStyle = {
        overflow: "hidden",
        maxWidth: "20rem"
    }

    const bodyTemplate = (rowData) => {
        let text = rowData.TURN_HE_ADI ? rowData.TURN_HE_ADI === 'S' ? 'Si' : 'No' : 'No aplica'
        return (
            <div>
                <span>{text}</span>
            </div>
        );
    }
    
    return (
        <div style={{ width: '100%' }} className=' mt-6'>
            <Toast ref={toast} />
            <SkeletonTable load={loadPage} width='100%'>
                <div className="flex flex-column justify-content-center align-items-center w-full" style={{}}>
                    <Tooltip target=".info" />
                    <Toolbar className="w-full mt-6 "style={{maxWidth: '100%', background: 'linear-gradient(90deg, rgba(16, 97, 162, 1) 0%, rgba(2, 150, 207, 1) 100%)', color: 'white' }} 
                        start={leftToolbarTemplate} end={rightToolbarTemplate}/>
                    <div className='flex' style={{width: '100%', flexDirection: 'column', paddingRight: 5, paddingLeft: 5}}>
                        <Dialog header="Programado" visible={isOpenActive} position="top" style={{width: width <= 768 && '100%'}}
                            draggable={false} resizable={false} modal onHide={() => setIsOpenActive(!isOpenActive)}>
                            <DataTable className="card text-xs h-full" value={liveDataFilter.ACTIVE}
                                dataKey="NUMBER_ID" style={{ height: '65vh', width: width > 768 ? '26rem' : '100%' }}
                                size="small" filters={filters1} filterDisplay="menu" scrollable={width <= 1024 && width > 768 ? true : false} scrollHeight={width <= 1024 && width > 768 && "51vh"}
                                globalFilterFields={['NUMBER_ID', 'NAME', 'BIRTHDAY']}
                            >
                                <Column header="Empleado" field='FULL_CONTRACT' body={(item) => employeeTableTemplate(item, 'active')} filterMatchModeOptions={matchModes} filter filterPlaceholder="Buscar" sortable></Column>
                                {/* <Column header="Ingreso" field='MARKED' filterMatchModeOptions={matchModes} filter filterPlaceholder="Buscar" sortable></Column> */}
                            </DataTable>
                        </Dialog>
                        <Dialog header="Vacaciones" visible={isOpenVacation} position="top" style={{width: width <= 768 && '100%'}}
                            draggable={false} resizable={false} modal onHide={() => setIsOpenVacation(!isOpenVacation)}>
                            <DataTable className="card text-xs h-full" value={liveDataFilter.VACATION}
                                dataKey="NUMBER_ID" style={{ height: '65vh', width: width > 768 ? '26rem' : '100%' }}
                                size="small" filters={filters1} filterDisplay="menu" scrollable={width <= 1024 && width > 768 ? true : false} scrollHeight={width <= 1024 && width > 768 && "51vh"}
                                globalFilterFields={['NUMBER_ID', 'NAME', 'BIRTHDAY']}
                            >
                                <Column header="Empleado" field='FULL_CONTRACT' body={(item) => employeeTableTemplate(item, 'vacation')} filterMatchModeOptions={matchModes} filter filterPlaceholder="Buscar" sortable></Column>
                            </DataTable>
                        </Dialog>
                        <Dialog header="Ausentismos" visible={isOpenAbsence} position="top" style={{width: width <= 768 && '100%'}}
                            draggable={false} resizable={false} modal onHide={() => setIsOpenAbsence(!isOpenAbsence)}>
                            <DataTable className="card text-xs h-full" value={liveDataFilter.ABSENCE}
                                dataKey="NUMBER_ID" style={{ height: '65vh', width: width > 768 ? '26rem' : '100%' }}
                                size="small" filters={filters1} filterDisplay="menu" scrollable={width <= 1024 && width > 768 ? true : false} scrollHeight={width <= 1024 && width > 768 && "51vh"}
                                globalFilterFields={['NUMBER_ID', 'NAME', 'BIRTHDAY']}
                            >
                                <Column header="Empleado" field='FULL_CONTRACT' body={(item) => employeeTableTemplate(item, 'absence')} filterMatchModeOptions={matchModes} filter filterPlaceholder="Buscar" sortable></Column>
                                {/* <Column header="Contingencia" field='CONTINGENCY_DETAIL' filterMatchModeOptions={matchModes} filter filterPlaceholder="Buscar" sortable></Column> */}
                            </DataTable>
                        </Dialog>
                        <Dialog header="Sin programación" visible={isOpenInactive} position="top" style={{width: width <= 768 && '100%'}}
                            draggable={false} resizable={false} modal onHide={() => setIsOpenInactive(!isOpenInactive)}>
                            <DataTable className="card text-xs h-full" value={liveDataFilter.INACTIVE}
                                dataKey="NUMBER_ID" style={{ height: '65vh', width: width > 768 ? '26rem' : '100%' }}
                                size="small" filters={filters1} filterDisplay="menu" scrollable={width <= 1024 && width > 768 ? true : false} scrollHeight={width <= 1024 && width > 768 && "51vh"}
                                globalFilterFields={['NUMBER_ID', 'NAME', 'BIRTHDAY']}
                            >
                                <Column header="Empleado" field='FULL_CONTRACT' body={(item) => employeeTableTemplate(item, 'inactive')} filterMatchModeOptions={matchModes} filter filterPlaceholder="Buscar" sortable></Column>
                            </DataTable>
                        </Dialog>
                        <Dialog header={birthdayHeader} visible={isOpenBirthdays} position="top" style={{width: width <= 768 && '90%' }}
                            draggable={false} resizable={false} modal onHide={() => setIsOpenBirthdays(!isOpenBirthdays)}>
                            <DataTable className="card text-xs h-full" value={rowsBirthdayFilter} paginator paginatorTemplate={template3} first={first2Birthday} rows={rows2Birthday}
                                onPage={onCustomPage2Birthday} dataKey="NUMBER_ID" style={{ height: '65vh', width: width > 768 ? '34rem' : '100%' }}
                                size="small" filters={filters1} filterDisplay="menu" scrollable={width <= 1024 && width > 768 ? true : false} scrollHeight={width <= 1024 && width > 768 && "51vh"}
                                globalFilterFields={['NUMBER_ID', 'NAME', 'BIRTHDAY']}
                            >
                                <Column field="NUMBER_ID" header="Empleado" body={photoBodyTemplate} filterMatchModeOptions={matchModes} filter filterPlaceholder="Buscar por id" sortable></Column>
                                <Column field="BIRTHDAY" header="Día" filterMatchModeOptions={matchModes} filter filterPlaceholder="Buscar por tipo" sortable></Column>
                                <Column field="ENTITY_NAME" header="Empresa" filterMatchModeOptions={matchModes} filter filterPlaceholder="Buscar por empresa" sortable></Column>
                                <Column field="CLIENT_NAME" header="Cliente" filterMatchModeOptions={matchModes} filter filterPlaceholder="Buscar por cliente" sortable></Column>
                            </DataTable>
                        </Dialog>
                        <Dialog header={headerAprobar} footer={footerAprobar} visible={isOpenA} bo
                            position="top" style={{ width: "26rem" }} draggable={false} resizable={false} modal onHide={hideModalA}>
                        </Dialog>
                        <Dialog header={headerRechazar} footer={footerRechazar} visible={isOpenR} bo
                            position="top" style={{ width: "26rem" }} draggable={false} resizable={false} modal onHide={hideModalR}>
                        </Dialog>
                        <Dialog header={detailHeader} visible={isOpenD} position="top" style={tipo !== "TRK" ? { width: "26rem" } : { width: width > 768 ? "70vw" : "95vw" , height: "90vh" }}
                            draggable={false} resizable={false} modal onHide={hideModalD}>
                            {tipo === "VAC" ? <><label style={labelStyle} htmlFor="label">Dias consolidado</label>
                                <InputNumber min={0} value={consolidado} placeholder="Dias consolidado" disabled={true} />
                                <label style={labelStyle} htmlFor="label">Dias tiempo</label>
                                <InputNumber min={0} value={diasTiempo} placeholder="Dias tiempo" disabled={true} />
                                <label style={labelStyle} htmlFor="label">Dias Dinero</label>
                                <InputNumber min={0} value={diasDinero} placeholder="Dias Dinero" disabled={true} />
                                <label style={labelStyle} htmlFor="label">Fecha inicio</label>
                                <Calendar id="navigators" value={fechaInicio} locale="es"
                                    dateFormat="dd-mm-yy" yearRange="2010:2030" showIcon disabled={true}
                                />
                                <label style={labelStyle} htmlFor="label">Fecha fin</label>
                                <Calendar id="navigators" value={fechaFin} locale="es" dateFormat="dd-mm-yy"
                                    yearRange="2010:2030" disabled={true} showIcon />
                                {adjunto &&
                                    <>
                                        <label style={labelStyle} htmlFor="label">Adjunto</label>
                                        <Button className='file-btn' style={buttonStyle} label={width > 426 ? adjunto.NAME_FILE + "." + adjunto.TYPE_FILE : ""} icon="pi pi-download"
                                            onClick={() => window.location.href = adjunto.URL} tooltip={adjunto.NAME_FILE + "." + adjunto.TYPE_FILE} tooltipOptions={{ position: 'bottom' }} />
                                    </>
                                }</>
                                : tipo === "ABS" ?
                                    <div className='flex flex-column'>
                                        <label style={labelStyle} htmlFor="label">Fecha inicio</label>
                                        <Calendar id="navigators" value={fechaInicioAusentismo} disabled={true} locale="es"
                                            dateFormat="dd-mm-yy" yearRange="2010:2030" showIcon
                                        />
                                        <label style={labelStyle} htmlFor="label">Fecha inicio</label>
                                        <Calendar id="navigators" value={fechaFinAusentismo} locale="es"
                                            dateFormat="dd-mm-yy" yearRange="2010:2030" showIcon disabled={true}
                                        />
                                        <label style={labelStyle} htmlFor="label">Contingencia</label>
                                        <Dropdown value={contingencia} autofocus optionLabel='NAME'
                                            filter showClear filterBy="NAME" emptyMessage={"No hay tipos disponibles"}
                                            disabled={true} options={listaContingencia} placeholder={contingencia ? contingencia.NAME : 'Seleccione'} />
                                        <label style={labelStyle} htmlFor="label">Tiempo</label>
                                        <InputNumber min={0} value={tiempo} placeholder="Tiempo" disabled={true} />
                                        <label style={labelStyle} htmlFor="label">Observaciones</label>
                                        <InputTextarea maxLength={70} value={observaciones} disabled={true} rows={4} cols={30} />
                                        {adjunto &&
                                            <>
                                                <label style={labelStyle} htmlFor="label">Adjunto</label>
                                                <Button className='file-btn' style={buttonStyle} label={width > 426 ? adjunto.NAME_FILE + "." + adjunto.TYPE_FILE : ""} icon="pi pi-download"
                                                    onClick={() => window.location.href = adjunto.URL} tooltip={adjunto.NAME_FILE + "." + adjunto.TYPE_FILE} tooltipOptions={{ position: 'bottom' }} />
                                            </>
                                        }
                                    </div>
                                    : tipo === 'TRK' ?
                                        <>
                                            <Maps2 latitud={[latitud]} longitud={[longitud]} descripcion={[trackDescription]} icon={[trackFotos]} info={[trackInfo]} />
                                            {/* <div className="carousel-demo2">
                                            <Carousel value={trackFotos} numVisible={1} numScroll={1} itemTemplate={itemTemplate} header={header} className="custom-carousel" />
                                        </div> */}
                                        </>
                                        :
                                        <>
                                            <label className='font-bold' style={labelStyle} htmlFor="label">Ingreso:</label>
                                            <span className='font-bold'>Fecha: </span>
                                            <span>{trackInfo.DATE_IN} </span>
                                            <span className='font-bold'>Hora: </span>
                                            <span>{trackInfo.TIME_IN} </span><br />
                                            <label className='font-bold' style={labelStyle} htmlFor="label">Salida:</label>
                                            <span className='font-bold'>Fecha: </span>
                                            <span>{trackInfo.DATE_OUT} </span>
                                            <span className='font-bold'>Hora: </span>
                                            <span>{trackInfo.TIME_OUT}</span><br />
                                            {trackInfo.TURN_HE_ADI && <><span className='font-bold'>Causal: {trackInfo.TURN_HE_ADI === 'S' ? "Si" : "No"}</span><br /><br /></>}
                                            <Button label='Ver ubicación' icon='pi pi-eye' size='small' onClick={showModalMapa} /><br /><br />
                                            {trackFotos[0] && trackFotos[0].DETAIL && trackFotos[0].DETAIL.length > 0 &&
                                                <div>
                                                    <Galleria value={trackFotos[0].DETAIL} responsiveOptions={responsiveOptions} numVisible={5} style={{ maxWidth: '640px'}}
                                                        item={itemTemplate} thumbnail={thumbnailTemplate} />
                                                </div>
                                            }
                                        </>
                            }
                        </Dialog>
                        <Dialog visible={isOpenMapa} draggable={false} resizable={false} modal onHide={hideModalMapa} style={{ width: width > 768 ? "70vw" : '95%', height: "90vh" }}>
                            <Maps2 latitud={latitud} longitud={longitud} descripcion={[]} icon={trackFotos} info={[trackInfo]} />
                        </Dialog>
                        <Dialog header={addHeaderCausal} footer={addFooterCausal} visible={isOpenCausal}
                            position="top" style={{ width: "26rem" }} draggable={false} resizable={false} modal onHide={hideModalCausal}>
                            <Dropdown value={causal} autofocus optionLabel='description' onChange={(e) => setCausal(e.value)} style={{ width: "20rem" }}
                                filter showClear filterBy="description" emptyMessage={"No hay causales disponibles"} tooltip={causal && causal.descripcion}
                                options={noveltyCauseList} placeholder={causal ? causal.description : 'Seleccione'} />
                        </Dialog>
                        <div className='flex flex-column' style={{ width: '100%', marginBottom: width <= 768 && '0.5rem' }}>
                            {width > 768 ?
                                <div className='flex flex-row'>
                                    {group1[0]}
                                    {group1[1]}
                                </div>
                                :
                                group1.map(element => {
                                    return element
                                })
                            }
                        </div>
                        <Toolbar className='pending card flex flex-row' start={leftToolbarTemplatePending} end={rightToolbarTemplatePending}
                            style={{ background: 'linear-gradient(90deg, rgba(16, 97, 162, 1) 0%, rgba(2, 150, 207, 1) 100%)', color: 'white', maxWidth: '100%' }}
                        />
                        <SkeletonTable load={loadPending}>
                            <div>
                                <DataTable className="card text-xs" value={rows} paginator paginatorTemplate={template7} first={first2} rows={rows2} onPage={onCustomPage2}
                                    selectionMode="multiple" selection={registros} onSelectionChange={(e) => setRegistros(e.value)} dataKey="REQUESTS_ID"
                                    size="small" filters={filters1} filterDisplay="menu"
                                    globalFilterFields={['REQUESTS_ID', 'NOVELTY', 'CONTRACT_ID', 'CONTRACT', 'START_DATE', 'UNITY', 'END_DATE', 'STATUS']}
                                    header={header1} >
                                    <Column selectionMode="multiple" headerStyle={{ width: '3em' }}></Column>
                                    <Column field="REQUESTS_ID" header="Id solicitud" filterMatchModeOptions={matchModes} filter filterPlaceholder="Buscar por id" sortable></Column>
                                    <Column field="NOVELTY" header="Tipo solicitud" filterMatchModeOptions={matchModes} filter filterPlaceholder="Buscar por tipo" sortable></Column>
                                    <Column field="CONTRACT_ID" header="Contrato" filterMatchModeOptions={matchModes} filter filterPlaceholder="Buscar por contrato" sortable></Column>
                                    <Column field="CONTRACT" header="Nombre" filterMatchModeOptions={matchModes} filter filterPlaceholder="Buscar por nombre" sortable></Column>
                                    <Column field="ENTITY_NAME" header="Empresa" filterMatchModeOptions={matchModes} filter filterPlaceholder="Buscar por empresa" sortable></Column>
                                    <Column field="CLIENT_NAME" header="Cliente" filterMatchModeOptions={matchModes} filter filterPlaceholder="Buscar por cliente" sortable></Column>
                                    <Column field="START_DATE" header="Feha inicio" filterMatchModeOptions={matchModes} filter filterPlaceholder="Buscar por fecha inicio" sortable></Column>
                                    {/* <Column field="UNITY" header="Dias" filterMatchModeOptions={matchModes} filter filterPlaceholder="Buscar por días" sortable></Column> */}
                                    <Column field="END_DATE" header="Feha fin" filterMatchModeOptions={matchModes} filter filterPlaceholder="Buscar por fecha fin" sortable></Column>
                                    <Column field="TYPE" header="Marcación" filterMatchModeOptions={matchModes} filter filterPlaceholder="Buscar por fecha fin" sortable></Column>
                                    <Column field="TIME" bodyStyle={{textAlign: 'start', overflow: 'visible', width: "10rem"}} headerStyle={{ width: '10rem', textAlign: 'center' }} header="Hora" filterMatchModeOptions={matchModes} filter filterPlaceholder="Buscar por fecha fin" sortable></Column>
                                    <Column field="TURN_HE_ADI" header="Causal" body={bodyTemplate} filterMatchModeOptions={matchModes} filter filterPlaceholder="Buscar por estado" sortable></Column>
                                    <Column field="STATUS" header="Estado" filterMatchModeOptions={matchModes} filter filterPlaceholder="Buscar por estado" sortable></Column>
                                    <Column header="Acciones" headerStyle={{ width: '10rem', textAlign: 'center' }} bodyStyle={{ textAlign: 'center', overflow: 'visible', width: "10rem" }} body={actionBodyTemplate} />
                                </DataTable>
                            </div>
                        </SkeletonTable>
                        <div className='flex flex-column' style={{ width: '100%' }}>
                            {width > 768 ?
                                <div className={'flex flex-row justify-content-between '}>
                                    {group2[0]}
                                    {group2[1]}
                                </div>
                                :
                                group2.map(element => {
                                    return element
                                })
                            }
                        </div>
                    </div>
                </div>
            </SkeletonTable>
        </div>
    )
}

export default Dashboard